import React, { useEffect, useRef } from 'react';
import BeefreeSDK from '@beefree.io/sdk';
import { Box } from '@material-ui/core';

import defaultTemplate from './default_template';

const CLIENT_ID = '5639fdec-77bb-46c5-ac70-c86141774f78';
const CLIENT_SECRET = 'w5FVR3NSVAGJe4NxztbPmOwe48QkYcUfLduQGoNo2IokxNJ7A5Me';
const CLIENT_UID = 'campus-tools';

const BeeEditor = ({ template = defaultTemplate, onSave, onError, onChange }) => {
  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  });

  useEffect(() => {
    const beeConfig = {
      autosave: false,
      container: 'bee-plugin-container',
      language: 'en-US',
      trackChanges: true,
      onError,
      onSave,
      onChange: (json, detail, version) => {
        if (onChangeRef.current) onChangeRef.current(json, detail, version);
      },
    };

    const init = async () => {
      const builder = new BeefreeSDK();

      await builder.UNSAFE_getToken(CLIENT_ID, CLIENT_SECRET, CLIENT_UID);

      await builder.start(beeConfig, template);
    };

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Box height="100%" id="bee-plugin-container" />;
};

export default BeeEditor;
